function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import styled from "styled-components";
import classNames from "classnames";
import { Row, Col } from "../grid";
var MainViewContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.splitView) === null || ref === void 0 ? void 0 : ref.mainView;
});
var SecondaryViewContainer = styled.div(_templateObject1(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.splitView) === null || ref === void 0 ? void 0 : ref.secondaryView;
});
var SplitViewContainer = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.splitView) === null || ref === void 0 ? void 0 : ref.container;
});
var Switcher = styled.ul(_templateObject3(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.splitView) === null || ref === void 0 ? void 0 : ref.switcher;
});
var SplitView = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(SplitView, Component);
    var _super = _createSuper(SplitView);
    function SplitView(props) {
        _classCallCheck(this, SplitView);
        var _this;
        _this = _super.call(this, props);
        _this.toggleView = function(view) {
            _this.setState({
                mainView: Boolean(view && view === "main")
            });
            if (_this.props.handleViewChange) {
                _this.props.handleViewChange(view);
            }
        };
        _this.MainView = function(param) {
            var children = param.children;
            return /*#__PURE__*/ React.createElement(MainViewContainer, {
                className: _this.state.mainView ? "active-view" : "hidden-view"
            }, children);
        };
        _this.SecondaryView = function(param) {
            var children = param.children;
            return /*#__PURE__*/ React.createElement(SecondaryViewContainer, {
                className: !_this.state.mainView ? "active-view" : "hidden-view"
            }, children);
        };
        _this.state = {
            mainView: true
        };
        return _this;
    }
    var _proto = SplitView.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.getToggleView) {
            this.props.getToggleView(this.toggleView);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, mainLabel = _props.mainLabel, secondaryLabel = _props.secondaryLabel, children = _props.children, betweenLabel = _props.betweenLabel, className = _props.className;
        return /*#__PURE__*/ React.createElement(SplitViewContainer, {
            className: classNames("container", className)
        }, /*#__PURE__*/ React.createElement(Row, {
            middle: "xs",
            center: "xs"
        }, /*#__PURE__*/ React.createElement(Col, {
            lg: 8,
            md: 10,
            sm: 12,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Switcher, {
            className: "split-view-switcher"
        }, /*#__PURE__*/ React.createElement("li", {
            className: this.state.mainView ? "active" : "",
            onClick: function() {
                return _this.toggleView("main");
            }
        }, mainLabel), betweenLabel && /*#__PURE__*/ React.createElement("li", {
            className: "between-label"
        }, betweenLabel), /*#__PURE__*/ React.createElement("li", {
            className: !this.state.mainView ? "active" : "",
            onClick: function() {
                return _this.toggleView("secondary");
            }
        }, secondaryLabel)))), children({
            MainView: this.MainView,
            SecondaryView: this.SecondaryView
        }));
    };
    return SplitView;
}(Component);
export default SplitView;
